import React, { useState, useEffect } from "react";
import {
  getPendingApprovals,
  updatePendingApprovals,
  getPendingBulkSaleApprovals,
  updatePendingBulkSaleApprovals,
  getPendingPurchaseApprovals,
  updatePendingPurchaseApprovals
} from "../../../api/endpoints/allReports";

import { authSelector } from "../../../store/selectors/index";
import { useSelector } from "react-redux";
import { message } from "antd";
import { FaCheck } from "react-icons/fa";
import { ImCross } from "react-icons/im";
import { useNavigate } from 'react-router-dom';


const EntryVerification = () => {
  const { user, access_token } = useSelector(authSelector);

  const [itemsQueue, setItemsQueue] = useState([]);
  const [itemsQueueBulkSale, setItemsQueueBulkSale] = useState([]);
  const [itemsQueuePurchase, setItemsQueuePurchase] = useState([]); // NEW PURCHASE STATE

  const navigate = useNavigate();

  // ========================= EDIT HANDLER (ALL 3 APIs) =========================
  const editHandler = async () => {
    let results = await getPendingApprovals(access_token);              // normal
    let bulkSaleResults = await getPendingBulkSaleApprovals(access_token); // bulk sale
    let purchaseResults = await getPendingPurchaseApprovals(access_token); // purchase

    results = results || { success: false, data: [] };
    bulkSaleResults = bulkSaleResults || { success: false, data: [] };
    purchaseResults = purchaseResults || { success: false, data: [] };

    setItemsQueue([]);
    setItemsQueueBulkSale([]);
    setItemsQueuePurchase([]);

    const emptyNormal = !Array.isArray(results.data) || results.data.length === 0;
    const emptyBulk = !Array.isArray(bulkSaleResults.data) || bulkSaleResults.data.length === 0;
    const emptyPurchase = !Array.isArray(purchaseResults.data) || purchaseResults.data.length === 0;

    if (emptyNormal && emptyBulk && emptyPurchase) {
      message.error("No Record Found");
      return;
    }

    // NORMAL ENTRIES
    if (results.success && Array.isArray(results.data)) {
      const payload = results.data.map((curr) => ({
        id: curr.id,
        enteredOn: curr.enteredOn,
        generalLedgerCode: Number(curr.generalLedgerCode),
        generalLedgerDescription: curr.chartOfAccount?.description || "",
        partyName: curr.party?.partyName || null,
        description: curr.description,
        voucherNumber: curr.voucherNumber,
        voucherType: curr.voucherType,
        debit: curr.debit,
        credit: curr.credit,
        siteId: curr.siteId,
      }));
      setItemsQueue(payload);
    }

    // BULK SALE ENTRIES
    if (bulkSaleResults.success && Array.isArray(bulkSaleResults.data)) {
      const payloadBulkSale = bulkSaleResults.data.map((curr) => ({
        id: curr.id,
        dateEntered: curr.enteredOn,
        shift: curr.shift,
        partyId: Number(curr.partyId),
        glDescription: curr.chartOfAccount?.description || "",
        tank: curr.tankNumber,
        glCode: Number(curr.generalLedgerCode),
        amount: Number(curr.amount),
        disc: Number(curr.cash),
        shortQuantity: Number(curr.shortQuantity),
        quantity: Number(curr.quantity),
        purchaseRate: Number(curr.purchaseRate),
        saleRate: Number(curr.saleRate),
        itemCode: curr.itemCode,
        itemName: curr.item?.itemName || "",
        remrks: curr.remrks,
        lorryNo: curr.lorryNo,
      }));
      setItemsQueueBulkSale(payloadBulkSale);
    }

    // PURCHASE ENTRIES
    if (purchaseResults.success && Array.isArray(purchaseResults.data)) {
      const payloadPurchase = purchaseResults.data.map((curr) => ({
        id: curr.id,
        dateEntered: curr.enteredOn,
        shift: curr.shift,
        partyId: Number(curr.partyId),
        code: curr.itemCode,
        glDescription: curr.chartOfAccount?.description || "",
        name: curr.item?.itemName || "",
        partyName: curr.party?.partyName || "",
        quantity: Number(curr.quantity),
        purchaseRate: Number(curr.purchaseRate),
        cashAmount: Number(curr.cashAmount),
        withHoldingTax: Number(curr.withHoldingTax),
        creditAmount: Number(curr.creditAmount),
        tank: curr.tankNumber,
        invoiceNo: curr.invoiceNumber,
    invoiceDate: curr.invoiceDate,
        glCode: Number(curr.generalLedgerCode),
        saleRate: Number(curr.saleRate),
        salesTax: Number(curr.saleTax),
        rebate: Number(curr.gst),
        shortDip: Number(curr.shortDip),
        shortQty: Number(curr.shortQuantity),
        lorryNo: curr.lorryNumber,
        freight: Number(curr.frieght),
        depoExp: Number(curr.depoExpense),
      }));
      setItemsQueuePurchase(payloadPurchase);
    }
  };

  // INITIAL LOAD
  useEffect(() => {
    editHandler();
  }, []);

  // =========================== APPROVAL FUNCTIONS ===========================

  const approval = async (ele) => {
    const response = await updatePendingApprovals({ id: ele.id, approved: 1 }, access_token);
    response.success ? message.success(response.message) : message.error(response.message);
    editHandler();
  };

  const declineApproval = async (ele) => {
    const response = await updatePendingApprovals({ id: ele.id }, access_token);
    response.success ? message.success(response.message) : message.error(response.message);
    editHandler();
  };

  const approvalBulkSale = async (ele) => {
    const response = await updatePendingBulkSaleApprovals({ id: ele.id, approved: 1 }, access_token);
    response.success ? message.success(response.message) : message.error(response.message);
    editHandler();
  };

  const approvalPurchase = async (ele) => {
    const response = await updatePendingPurchaseApprovals({ id: ele.id, approved: 1 }, access_token);
    response.success ? message.success(response.message) : message.error(response.message);
    editHandler();
  };

  const declinePurchase = async (ele) => {
    const response = await updatePendingPurchaseApprovals({ id: ele.id }, access_token);
    response.success ? message.success(response.message) : message.error(response.message);
    editHandler();
  };


  const closeTab = () => navigate("/reportsComponent");

  return (
    <div className="min-h-screen w-full bg-white p-4">

      {/* ================= NORMAL APPROVALS ================= */}
      <div className="border border-black rounded-md mb-6 bg-white">
        <div className="bg-black text-white text-center py-2 rounded-t-md font-semibold">Pending Approvals</div>

        <table className="w-full text-sm text-black border-collapse">
          <thead>
            <tr className="bg-gray-200 text-black border border-black">
              <th className="border border-black px-2 py-2">Date</th>
              <th className="border border-black px-2 py-2">V.No.</th>
              <th className="border border-black px-2 py-2">V.Type</th>
              <th className="border border-black px-2 py-2">GL Description</th>
              <th className="border border-black px-2 py-2">Party</th>
              <th className="border border-black px-2 py-2">Description</th>
              <th className="border border-black px-2 py-2">Debit</th>
              <th className="border border-black px-2 py-2">Credit</th>
              {user.authorized && <th className="border border-black px-2 py-2">Action</th>}
            </tr>
          </thead>

          <tbody>
            {itemsQueue.map((ele, i) => (
              <tr key={i} className="border border-black">
                <td className="border border-black px-2 py-2">{ele.enteredOn}</td>
                <td className="border border-black px-2 py-2">{ele.voucherNumber}</td>
                <td className="border border-black px-2 py-2">{ele.voucherType}</td>
                <td className="border border-black px-2 py-2">{ele.generalLedgerDescription}</td>
                <td className="border border-black px-2 py-2">{ele.partyName || "N/A"}</td>
                <td className="border border-black px-2 py-2">{ele.description}</td>
                <td className="border border-black px-2 py-2">{ele.debit}</td>
                <td className="border border-black px-2 py-2">{ele.credit}</td>

                {user.authorized && (
                  <td className="border border-black px-2 py-2 text-center">
                    <div className="flex justify-center">
                      <FaCheck className="mx-2 cursor-pointer text-green-600" onClick={() => approval(ele)} />
                      <ImCross className="mx-2 cursor-pointer text-red-600" onClick={() => declineApproval(ele)} />
                    </div>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* ================= BULK SALE APPROVALS ================= */}
      <div className="border border-black rounded-md mb-6 bg-white">
        <div className="bg-black text-white text-center py-2 rounded-t-md font-semibold">Pending Bulk Sale Approvals</div>

        <table className="w-full text-sm text-black border-collapse">
          <thead>
            <tr className="bg-gray-200 text-black border border-black">
              {/* <th className="border border-black px-2 py-2">S.No</th> */}
              <th className="border border-black px-2 py-2">Date</th>
              <th className="border border-black px-2 py-2">Party</th>
              <th className="border border-black px-2 py-2">Item Name</th>
              <th className="border border-black px-2 py-2">Lorry No</th>
              <th className="border border-black px-2 py-2">Description</th>
              <th className="border border-black px-2 py-2">Qty</th>
              <th className="border border-black px-2 py-2">S/Qty</th>
              <th className="border border-black px-2 py-2">P/Rate</th>
              <th className="border border-black px-2 py-2">S/Rate</th>
              <th className="border border-black px-2 py-2">Disc</th>
              <th className="border border-black px-2 py-2">Amount</th>
              <th className="border border-black px-2 py-2">Tank</th>
              {user.authorized && <th className="border border-black px-2 py-2">Action</th>}
            </tr>
          </thead>

          <tbody>
            {itemsQueueBulkSale.map((ele, i) => (
              <tr key={i} className="border border-black">
                <td className="border border-black px-2 py-2">{ele.dateEntered}</td>
                <td className="border border-black px-2 py-2">{ele.partyId}</td>
                <td className="border border-black px-2 py-2">{ele.itemName}</td>
                <td className="border border-black px-2 py-2">{ele.lorryNo}</td>
                <td className="border border-black px-2 py-2">{ele.remrks}</td>
                <td className="border border-black px-2 py-2">{ele.quantity}</td>
                <td className="border border-black px-2 py-2">{ele.shortQuantity}</td>
                <td className="border border-black px-2 py-2">{ele.purchaseRate}</td>
                <td className="border border-black px-2 py-2">{ele.saleRate}</td>
                <td className="border border-black px-2 py-2">{ele.disc}</td>
                <td className="border border-black px-2 py-2">{ele.amount}</td>
                <td className="border border-black px-2 py-2">{ele.tank}</td>

                {user.authorized && (
                  <td className="border border-black px-2 py-2 text-center">
                    <div className="flex justify-center">
                      <FaCheck className="mx-2 cursor-pointer text-green-600" onClick={() => approvalBulkSale(ele)} />
                      <ImCross className="mx-2 cursor-pointer text-red-600" />
                    </div>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* ================= PURCHASE APPROVALS ================= */}
      <div className="border border-black rounded-md mb-6 bg-white">
        <div className="bg-black text-white text-center py-2 rounded-t-md font-semibold">Pending Purchase Approvals</div>

        <table className="w-full text-sm text-black border-collapse">
          <thead>
            <tr className="bg-gray-200 text-black border border-black">
              <th className="border border-black px-2 py-2">Date</th>
              <th className="border border-black px-2 py-2">Invoice No</th>
              <th className="border border-black px-2 py-2">Item Name</th>
              <th className="border border-black px-2 py-2">Party</th>
              <th className="border border-black px-2 py-2">Qty</th>
              <th className="border border-black px-2 py-2">Purchase Rate</th>
              <th className="border border-black px-2 py-2">Credit Amt</th>
              <th className="border border-black px-2 py-2">Tanker</th>
              {user.authorized && <th className="border border-black px-2 py-2">Action</th>}
            </tr>
          </thead>

          <tbody>
            {itemsQueuePurchase.map((ele, i) => (
              <tr key={i} className="border border-black">
                <td className="border border-black px-2 py-2">{ele.dateEntered}</td>
                <td className="border border-black px-2 py-2">{ele.invoiceNo}</td>
                <td className="border border-black px-2 py-2">{ele.name}</td>
                <td className="border border-black px-2 py-2">{ele.partyName}</td>
                <td className="border border-black px-2 py-2">{ele.quantity}</td>
                <td className="border border-black px-2 py-2">{ele.purchaseRate}</td>
                <td className="border border-black px-2 py-2">{ele.creditAmount}</td>
                <td className="border border-black px-2 py-2">{ele.tank}</td>

                {user.authorized && (
                  <td className="border border-black px-2 py-2 text-center">
                    <div className="flex justify-center">
                      <FaCheck
                        className="mx-2 cursor-pointer text-green-600"
                        onClick={() => approvalPurchase(ele)}
                      />
                      <ImCross
                        className="mx-2 cursor-pointer text-red-600"
                        onClick={() => declinePurchase(ele)}
                      />
                    </div>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div>
        <button onClick={closeTab} className="bg-black text-white mt-4 px-4 py-2 rounded">Exit</button>
      </div>

    </div>
  );
};

export default EntryVerification;